//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  mounted(){
    this.$refs.search.addEventListener('focusout', ()=>{
      setTimeout(()=>{
        this.searchState = false
      },100)
    })
  },
  methods:{
    logout(){
      this.$auth.logout()
    },
    async searchMode(){
      await new Promise((r)=>{
        this.searchState = true;
        r()
      })

      this.$refs.search.focus()

    },
  },
  data(){
    return {
      searchText: '',
      searchState: false
    }
  },

}
